export default {
  common: {
    title: 'AI Smart Assistant',
    快捷功能: 'Quick Access',
    为您推荐: 'Recommended for You',
    内容声明: 'AI-generated, for reference only',
    思考中: 'Thinking',
    取消: 'Cancel',
    保存: 'Save',
    确定: 'Confirm',
    新会话: 'New Session',
    开始新会话: 'Start New Session',
    加载中: 'Loading...',
    登录中: 'Logging in...',
    保存中: 'Saving...',
    保存成功: 'Success',
    保存失败: 'Failure',
  },
  card: {
    优选: 'FEAT',
    展商: 'Exhibitors',
    展品: 'Products',
    会议: 'Conferences',
    活动: 'Events',
    商机: 'Opportunities',
    广告: 'Ads',
    会议活动: 'Conferences & Events',
    AI推荐: 'AI Rec',
    展位号: 'Booth No.:',
  },
  message: {
    说话时间太短: 'Speaking time too short',
    没有听到说话: 'No speech detected',
    即将结束: 'Will end in {s}s',
    没有更多了: 'No more',
    暂无会话记录: 'No session records',
    链接已复制: 'Link copied. Please open in browser.',
    链接复制失败: 'Failed to copy link',
    邮箱已复制: 'Email copied',
    邮箱复制失败: 'Failed to copy email',
  },
  agent: {
    按住说话: 'Hold to speak',
    录音中: 'Recording...',
    松手取消发送: 'Release to cancel sending',
    松开发送上滑取消: 'Release to send, swipe up to cancel',
    正在识别中: 'Recognizing...',
    已思考: 'Thought',
    思考中: 'Thinking',
    用时: '(took {s}s)',
    默认占位符: 'Send Message',
  },
  operation: {
    编辑: 'Rename',
    删除: 'Delete Session',
  },
  title: {
    重命名会话: 'Rename Session',
    会话记录: 'Session Records',
    今天: 'Today',
    昨天: 'Yesterday',
    三天内: 'Within 3 days',
    七天内: 'Within 7 days',
    更早: 'Earlier',
  },
  placeholder: {
    请输入会话名称: 'Please enter content',
  },
  error: {
    暂无权限: 'Access Denied',
    暂无权限提示: 'You do not have permission to access this page',
    暂无配置: 'No Configuration',
    暂无配置提示: 'Failed to load page configuration. Please verify your access permissions.',
    服务异常: 'Service Error',
    网络异常: 'Network Error',
    未知错误: 'Unknown Error',
    未知错误提示: 'An unknown error occurred, please try again later',
    页面不存在: 'Page Not Found',
    页面不存在提示: 'The page you visited does not exist or has been removed',
    服务异常提示: 'Server error, please try again later',
    重试: 'Retry',
    返回: 'Back',
    正在重试: 'Retrying...',
  },
  webview: {
    重新加载: 'Reload',
    加载超时: 'Loading timeout, please check your network',
    页面加载失败: 'Page load failed',
    页面加载中: 'Page loading...',
  },
  route: {
    展商地图: 'Exhibitor Map',
    详情: 'Details',
    小助手设定: 'Agent Settings',
  },
  map: {
    标题: 'Tip',
    提示: 'Enter Booth Navigator?',
    确认: 'Enter',
    取消: 'Cancel',
  },
  detailsPage: {
    基本信息: 'Basic Information',
    展商简介: 'Exhibitor Profile',
    产品简介: 'Product Overview',
    展品列表: 'Products List',
    更多展品推荐: 'More Products',
    注册资金: 'Reg. Capital:',
    成立时间: 'Date Founded:',
    注册地址: 'Reg. Address:',
    食品类型: 'Type of Food:',
    出口区域: 'Export Regions:',
    产品分类: 'Product Categorys:',
    所在地: 'Location:',
    详情: 'Details',
    展位号: 'Booth No.:',
    时间: 'Time:',
    地点: 'Location:',
    当前: 'Current',
    暂无展品数据: 'No product data available'
  },
  settings: {
    基础设定: 'Basic Settings',
    角色与风格: 'Role & Style',
    助手角色: 'Assistant Role',
    对话风格: 'Conversation Style',
    特殊要求: 'Special Requirements',
    其他设置: 'Other Settings',
    保存设置: 'Save Settings',
    深度思考: 'Depth Thinking',
    语言设置: 'Language',
    助手名称: 'Agent Name',
    请输入: 'Please enter',
  },
  enum: {
    role: {
      professionalAdviser: 'Expo Advisor',
      industryExpert: 'Industry Expert',
      exhibitionNavigator: 'Expo Navigator',
      caringAssistant: 'Kind Helper'
    },
    style: {
      enthusiastic: 'Warm and thorough',
      concise: 'Concise Pro',
      humorous: 'Witty Fun',
      rigorous: 'Rigorous'
    }
  }
}